/*
 * Collapsible Content Toggle
 *
 * Maneja el toggle de contenido colapsable usando las clases:
 *   - .collapsible: contenedor principal
 *   - .collapsible__content: contenido que se expande/colapsa
 *   - .collapsible__toggle: botón de toggle
 *
 * El atributo data-collapsed-height define la altura colapsada (default: 1.4em)
 */

window.initializeCollapsibleToggle = function () {
  document.querySelectorAll(".collapsible__toggle").forEach(button => {
    button.removeEventListener("click", toggleCollapsible);
    button.addEventListener("click", toggleCollapsible);
  });
};

window.toggleCollapsible = function (e) {
  const button = e.currentTarget;
  const parent = document.querySelector(button.dataset.target);

  if (!parent) {
    console.error(`Collapsible: No se encontró el contenedor con id: ${button.dataset.target}`);
    return;
  }

  const content = parent.querySelector(".collapsible__content");
  if (!content) {
    console.error("Collapsible: No se encontró .collapsible__content");
    return;
  }

  const collapsedHeight = parent.dataset.collapsedHeight || "1.4em";
  const isExpanded = parent.classList.contains("expanded");

  if (isExpanded) {
    // Colapsar: primero establecer altura actual explícita, luego animar a colapsado
    content.style.maxHeight = content.scrollHeight + "px";
    // Forzar reflow para que la transición funcione
    content.offsetHeight;
    content.style.maxHeight = collapsedHeight;
    button.textContent = "Mostrar más";
  } else {
    // Expandir: animar desde altura actual a scrollHeight
    content.style.maxHeight = content.scrollHeight + "px";
    button.textContent = "Mostrar menos";
  }

  parent.classList.toggle("expanded");
};

// Inicializar en los eventos relevantes
document.addEventListener("turbo:load", () => {
  window.initializeCollapsibleToggle();
});

document.addEventListener("turbo:render", () => {
  window.initializeCollapsibleToggle();
});

document.addEventListener("DOMContentLoaded", () => {
  window.initializeCollapsibleToggle();
});

document.addEventListener("ajax:success", () => {
  window.initializeCollapsibleToggle();
});

// Turbo Streams: reinicializar después de que se procesen los streams
document.addEventListener("turbo:before-stream-render", (event) => {
  requestAnimationFrame(() => {
    window.initializeCollapsibleToggle();
  });
});
